import Script from 'next/script';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { getSite } from '@/utils/getSite';
import { VideoPlaylist } from './VideoPlaylist';

export interface StandaloneVideoPlaylist extends StandaloneComponentProps {
  title?: string;
  playlistId?: string;
}

export const StandaloneVideoPlaylist: StandaloneComponent<StandaloneVideoPlaylist> = ({ title, playlistId }) => {
  const siteName = getSite();
  const topDomain = siteName === 'mabra' ? 'com' : 'se';

  if (!playlistId) {
    return null;
  }

  return (
    <>
      <VideoPlaylist
        data-variant="carousel"
        data-playlist-id={playlistId}
        data-title={title}
        data-site={`${siteName}.${topDomain}`}
        data-hide-video-titles
      />
      <Script id="aller-video-loader-cdn" src="https://cdn.video.aller.com/loader/latest/script.js" />
    </>
  );
};
